<template>
  <LayoutDataTable
    :isLoading="showTable || isLoading"
    :searchQuery="searchQuery"
    :perPage="perPage"
    :meta="dataMeta"
    :currentPage="currentPage"
    :totals="totals"
    :isShowTabs="true"
    :searchPlaceholder="$t('lbl_find_orders_by_order_code')"
    @setTab="handleTabClicked"
    @setPerPage="(value) => (perPage = value)"
    @setSearchQuery="(value) => (searchQuery = value)"
    @setCurrentPage="(value) => (currentPage = value)"
  >
    <template #default>
      <span class="ml-2">{{
        $t('lbl_filter_orders_by_expected_delivery_date_')
      }}</span>
      <b-row class="w-full pl-2 pr-3 d-flex" style="margin-top: 5px">
        <b-col>
          <b-row class="d-flex">
            <b-col style="min-width: 270px">
              <b-form-datepicker
                :locale="$i18n.locale"
                v-bind="$getCalendarLabel($i18n.locale)"
                id="start-date"
                :placeholder="$t('lbl_select_start_date')"
                v-model="fromDate"
                class="mb-2 mr-2"
                value-as-date
                today-button
                reset-button
              ></b-form-datepicker>
            </b-col>
            <span
              class="mb-2 font-weight-bold"
              style="height: 39px; line-height: 39px"
              >-</span
            >
            <b-col style="min-width: 270px">
              <b-form-datepicker
                :locale="$i18n.locale"
                v-bind="$getCalendarLabel($i18n.locale)"
                id="end-date"
                :placeholder="$t('lbl_select_end_date')"
                v-model="toDate"
                class="mb-2"
                value-as-date
                today-button
                reset-button
              ></b-form-datepicker>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="4">
          <b-form-select
            class="ml-2 mr-1"
            placeholder
            v-model="statusFilter"
            :options="statusFilterOptions"
          />
        </b-col>
      </b-row>
      <b-row class="w-full pl-2 pr-3 d-flex">
        <b-col v-if="followMode === 'follow'">
          <b-button @click="handleClickBellIcon(null, true)" v-b-tooltip.top :title="selectedRows.length===0 ? 'You have not selected any order.' : ''" :disabled="selectedRows.length===0" size="sm" variant="outline-primary">Unfollow</b-button>
          <p class="d-inline-block mb-2 ml-2" style="font-size: 12px">Selected {{ selectedRows.length }} out of {{ perPage }} rows</p>
        </b-col>
        <b-col v-if="followMode === 'floating'">
          <b-button @click="handleClickBellIcon(null, false)" v-b-tooltip.top :title="selectedRows.length===0 ? 'You have not selected any order.' : ''" :disabled="selectedRows.length===0" size="sm" variant="primary" class="mr-1">Follow</b-button>
          <p class="d-inline-block mb-2 ml-2" style="font-size: 12px">Selected {{ selectedRows.length }} out of {{ perPage }} rows</p>
        </b-col>
      </b-row>
      <b-table
        ref="refOrdersTable"
        id="refOrdersTable"
        class="position-relative"
        :items="fetchOrdersList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        hover
        :empty-text="$t('lbl_no_matching_records_found')"
        :sort-desc.sync="isSortDirDesc"
        @row-clicked="viewDetailOrders"
      >
        <!-- <template slot="row-details" slot-scope="scope">
          <div
            class="d-flex items-center"
            :class="index < scope.item.order_item.length - 1 ? 'mb-1' : ''"
            v-for="(product, index) in scope.item.order_item"
            :key="product.id"
          >
            <div class="mr-1">
              <img
                class="border rounded-sm"
                :height="48"
                :src="product.product_image"
                :alt="product.product_name"
              />
            </div>
            <div>
              <div
                class="text-primary font-weight-bold"
              >{{ product.product_name }} ({{ product.product_variant_unit }})</div>
              <div>
                <span>{{ appUtils.numberFormat(product.price, 'VNĐ') }}</span> x
                <span>{{ product.qty }}</span>
              </div>
            </div>
          </div>
        </template>-->
        <template #cell(selecting)="scope">
          <span class="d-inline-block" style="width: 20px">
            <b-form-checkbox v-model="scope.item.isSelected" @change="(e) => checkRow(e, scope.item)" style="width: 20px;"></b-form-checkbox>
          </span>
        </template>
        <template #cell(order_code)="scope">
          <span class="text-nowrap">
            <div
              v-if="scope.item.order_read_flag === 1"
              class="fade-loading"
            ></div>
            {{ scope.item.order_code }}
          </span>
        </template>
        <template #cell(customer)="scope">
          <span class="text-nowrap">{{ getCustomer(scope.item) }}</span>
        </template>
        <template #cell(address)="scope">
          <span class="text-nowrap">{{ getCustomerAddress(scope.item) }}</span>
        </template>
        <template #cell(phone)="scope">
          <span class="text-nowrap">{{ getCustomerPhone(scope.item) }}</span>
        </template>
        <template #cell(avatar)="scope">
          <div class="d-flex flex-nowrap position-relative">
            <span v-for="(follower, index) in scope.item.followers" :key="follower.id"
              class="text-nowrap avatar position-absolute d-flex items-center justify-center"
              :style="{left: 20*index+'px', zIndex: index.toExponential, height: '38px'}"
            >
              <b-img
                v-if="follower.user.avatar"
                :src="appUtils.getImageURL(follower.user.avatar)"
                @error="$set(follower, index, { ...follower, avatar: false })"
                fluid
                alt=""
                rounded="circle"
                style="width: 40px; object-fit: contain;"
              ></b-img>
              <span
                v-else
                class="b-avatar badge-minimal badge-light-primary rounded-circle"
                style="width: 40px; background-color: transparent;"
              >
                <svg
                  viewBox="0 0 16 16"
                  width="1em"
                  height="1em"
                  focusable="false"
                  role="img"
                  aria-label="person fill"
                  aria-hidden="true"
                  alt="avatar"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  class="bi-person-fill b-icon bi"
                >
                  <g>
                    <path
                      fill-rule="evenodd"
                      d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                    ></path>
                  </g>
                </svg>
              </span>
            </span>
          </div>
        </template>
        <template #cell(delivery_status)="scope">
          <div :set="(status = getDeliveryStatus(scope.item))">
            <!-- <b-badge v-if="status.title" :variant="status.color">{{ $t(`vn_translate.${status.title}`) }}</b-badge> -->
            <b-badge
              v-if="scope.item.order_item[0].order_processor_status == 100"
              variant="danger"
              >{{ $t('lbl_cancelled') }}</b-badge
            >
            <b-badge v-else-if="status.title" :variant="status.color">{{
              currLanguage == 'en'
                ? getTitleDeliveryStatusEn(scope.item.order_item[0])
                : status.title
            }}</b-badge>
          </div>
        </template>
        <template #cell(test_status)="scope">
          <div :set="(status = getTestStatusVariant(scope.item))">
            <b-badge :variant="status.color">{{ status.title }}</b-badge>
          </div>
        </template>
        <template #cell(order_date)="scope">
          <span class="text-nowrap">{{
            formatDate(scope.item.order_date, 'HH:mm DD/MM/YYYY')
          }}</span>
        </template>
        <template #cell(return_date)="scope">
          <span class="text-nowrap" style="width: 70px">{{
            formatDate(scope.item.return_date)
          }}</span>
          <WarningIcon
            v-if="
              getResultDateInfor(scope.item.return_date, scope.item).isShowBadge
            "
            class="margin-b-4"
            :fill="getResultDateInfor(scope.item.return_date).variant"
            :title="getResultDateInfor(scope.item.return_date).tooltip"
            v-b-tooltip.top
          ></WarningIcon>
        </template>
        <template #cell(action)="scope">
          <div class="text-right text-nowrap" @click.stop>
            <b-button
              :set="(isFollow = getIsFollow(scope.item.followers))"
              v-b-tooltip.hover.top
              :variant="isFollow ? 'outline-info' : 'outline-primary'"
              size="sm"
              :title="
                isFollow
                  ? $t('lbl_unfollow_order_s_notification')
                  : $t('lbl_follow_order_s_notification')
              "
              @click="handleClickBellIcon(scope.item.id, getIsFollow(scope.item.followers))"
            >
              <feather-icon
                size="16"
                :icon="isFollow ? 'BellOffIcon' : 'BellIcon'"
              />
            </b-button>
            <b-button
              v-if="
                scope.item.status === ORDERS_STATUS.RECEIVE_ORDERS ||
                scope.item.status === ORDERS_STATUS.WAITING_CONFIRM
              "
              v-b-tooltip.hover.top
              variant="outline-danger ml-1"
              size="sm"
              :title="$t('lbl_cancel_orders')"
              @click="deleteOrders(scope.item)"
              record
            >
              <feather-icon size="16" icon="XCircleIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-modal
        :busy="orders.isLoadingDetail"
        id="hodo-modal-scrollable"
        size="xl"
        scrollable
        hide-header
        ok-only
        :ok-title="$t('lbl_close')"
        v-model="showDetailOrder"
      >
        <OrdersDetail
          :isLoadingDetail="orders.isLoadingDetail"
          :recordData="orders.viewDetail"
        />
      </b-modal>
    </template>
  </LayoutDataTable>
</template>

<script>
import { BTable, BButton, BTooltip, BModal } from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'
import useOrdersList from './useOrdersList'
import { ref } from '@vue/composition-api'
import LayoutDataTable from '../../layouts/table/LayoutDataTable.vue'
import appUtils from '@/utils/appUtils'
import OrdersDetail from './Detail/index.vue'
import {
  ORDERS_STATUS,
  DELIVERY_STATUS,
  ORDER_FORM_PROCESSOR_STATUS
} from '@/utils/constant'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import WarningIcon from '@/components/WarningIcon.vue'

export default {
  name: 'OrdersList',
  components: {
    LayoutDataTable,
    BTable,
    BButton,
    BTooltip,
    BModal,
    OrdersDetail,
    WarningIcon
  },
  data() {
    return {
      appUtils,
      ORDER_FORM_PROCESSOR_STATUS,
      currLanguage: this.$store.state.language.currLanguage,
      selectedRows: [],
      user: {}
    }
  },
  computed: {
    ...mapGetters('app', ['statusOptions']),
    ...mapGetters('orders', ['filterList']),
    ...mapState({
      orders: (state) => state.orders
    })
  },
  async created() {
    this.user = appUtils.getLocalUser()
  },
  methods: {
    handleTabClicked(e) {
      switch (Number(e.target.ariaPosInSet)) {
        case 1:
          this.followMode = ""
          break;
        case 2:
          this.followMode = "follow"
          break;
        case 3:
          this.followMode = "floating"
          break;
        default:
          this.followMode = ""
          break;
      }
      this.selectedRows = []
    },
    checkRow(eventValue, row) {
      if (eventValue) {
        this.selectedRows.push(row)
        this.refOrdersTable.localItems[index].isSelected = true
      } else {
        this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
        this.refOrdersTable.localItems[index].isSelected = false
      }
    },
    getIsFollow(followers) {
      return followers?.map(f => f.user_id).includes(this.user.id) || false
    },
    async handleClickBellIcon(orderId, isFollow) {
      const param = {
        object_id: orderId ? [orderId] : this.selectedRows.map(row => row.id),
        type: 1
      }
      if (isFollow) {
        await this.$rf
          .getRequest("CommonRequest")
          .unfollowOrders(param)
      } else {
        await this.$rf
          .getRequest("CommonRequest")
          .followOrders(param)
      }
      this.refetchData();
    },
    getCustomer(row) {
      if (row.order_contact) {
        const customerSender = row.order_contact.find((x) => x.type === 1)
        return customerSender?.name
      } else {
        return ''
      }
    },
    getCustomerAddress(row) {
      if (row.order_contact) {
        const customerSender = row.order_contact.find((x) => x.type === 1)
        return customerSender?.address1 || customerSender?.address2
      } else {
        return ''
      }
    },
    getCustomerPhone(row) {
      if (row.order_contact) {
        const customerSender = row.order_contact.find((x) => x.type === 1)
        return customerSender?.phone
      } else {
        return ''
      }
    },
    getTestStatus(row) {
      const leastStepTests = row.order_item.map((item) => {
        return item.order_processor_status
      })
      const minStep = Math.min(...leastStepTests)
      return minStep ? minStep : row?.status
    },
    getTestStatusVariant(row) {
      const order_delivery_state = this.getTestStatus(row)
      switch (order_delivery_state) {
        case ORDERS_STATUS.RECEIVE_ORDERS:
          return {
            title: this.$t('lbl_processor_order_status.RECEIVE_ORDERS'),
            color: 'primary'
          }
        case ORDERS_STATUS.PROCESSING:
          return {
            title: this.$t('lbl_processor_order_status.PROCESSING'),
            color: 'info'
          }
        case ORDERS_STATUS.FINISHED:
          return {
            title: this.$t('lbl_processor_order_status.FINISHED'),
            color: 'success'
          }
        case ORDERS_STATUS.CANCELED:
          return {
            title: this.$t('lbl_processor_order_status.CANCELED'),
            color: 'danger'
          }

        default:
          return {
            title: this.$t('lbl_processor_order_status.RECEIVE_ORDERS'),
            color: 'primary'
          }
      }
    },
    getDeliveryStatus(row) {
      const leastStepTests = row.order_item.map((item) => {
        return item.delivery_status
      })
      const order_delivery_state = Math.min(...leastStepTests)
      const test = row.order_item?.find(
        (item) => item?.delivery_status === order_delivery_state
      )
      let status = {
        title:
          test?.delivery_states?.find(
            (state) => order_delivery_state === state.status
          )?.title || '',
        color: null
      }
      switch (order_delivery_state) {
        case DELIVERY_STATUS.RECEIVED:
        case DELIVERY_STATUS.SAMPLE_TAKEN:
          status.color = 'primary'
          break
        case DELIVERY_STATUS.PROCESSING:
        case DELIVERY_STATUS.PAYMENT:
        case DELIVERY_STATUS.SENDING:
          status.color = 'info'
          break
        case DELIVERY_STATUS.FINISHED:
        case DELIVERY_STATUS.DELIVERED:
          status.color = 'success'
          break
        default:
          status.color = 'primary'
          break
      }
      return status
    },
    refreshTable() {
      this.showTable = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refetchData()
        this.showTable = false
      }, 2000)
    },
    formatDate(time, format = 'DD/MM/YYYY') {
      if (!time) return '_'
      const date = moment.utc(time).format()
      return moment.utc(date).local().format(format)
    },
    handleViewOrder(item, index) {
      this.allOpenRows.map((ele) => {
        if (ele.id !== item.id && ele._showDetails) {
          this.$set(ele, '_showDetails', !ele._showDetails)
        }
      })
      this.allOpenRows = []
      this.$set(item, '_showDetails', !item._showDetails)
      this.allOpenRows.push(item)
    },
    async deleteOrders(record) {
      if (!record?.order_id) {
        return
      }

      const nodeEl = this.$createElement
      const messageVNode = nodeEl('div', {
        domProps: {
          innerHTML: `Bạn có muốn huỷ đơn hàng <strong>#${record.order_code}</strong> không?`
        }
      })

      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Huỷ đơn hàng',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Huỷ đơn',
          cancelTitle: 'Bỏ',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(async (value) => {
          if (value) {
            try {
              await this.$rf
                .getRequest('CommonRequest')
                .putCancelOrder(record.id)

              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Huỷ đơn hàng thành công'),
                  icon: 'CheckIcon',
                  variant: 'success'
                }
              })
              this.refetchData()
            } catch (error) {
              console.log(error)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Huỷ đơn hàng không thành công'),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            }
            // Code here...
            console.log(value)
          }
        })
        .catch((err) => {
          // An error occurred
        })
    },
    viewDetailOrders(order) {
      this.$store.commit("orders/updateFilterList", {
        keyword: this.searchQuery,
        mode: this.followMode,
        page_size: this.perPage,
        page_num: this.currentPage,
        supplier_id: appUtils.getLocalUser()?.supplierInfo?.id,
        sort_by: 'id',
        order: 'desc',
        status: this.statusFilter,
        from_date: this.fromDate ? this.fromDate.getTime() : this.fromDate,
        to_date: this.toDate ? this.toDate.getTime() : this.toDate
      })
      this.$router.push({ name: 'orderDetail', params: { id: order.id } })
    },
    getResultDateInfor(return_date, row = null) {
      const test_status = row ? this.getTestStatus(row) : 0
      const time = return_date - Date.now()
      if (
        !return_date ||
        [
          ORDERS_STATUS.FINISHED,
          ORDERS_STATUS.CANCELED,
          ORDER_FORM_PROCESSOR_STATUS.SUPPLIER_CANCEL
        ].includes(test_status)
      ) {
        return {
          isShowBadge: false
        }
      } else if (time < -86400000) {
        return {
          isShowBadge: true,
          variant: 'red',
          tooltip: this.$t('lbl_the_deadline_for_returning_results_has_passed')
        }
      } else if (time < 0) {
        return {
          isShowBadge: true,
          variant: 'red',
          tooltip: this.$t('lbl_results_are_due_today')
        }
      } else if (time < 86400000 * 3) {
        return {
          isShowBadge: true,
          variant: '#ffc107',
          tooltip: this.$t(
            'lbl_there_is_1_day_left_until_the_appointment_to_return_the_results',
            [Math.ceil(time / 86400000)]
          )
        }
      } else {
        return {
          isShowBadge: false
        }
      }
    },
    getTitleDeliveryStatusEn(arr) {
      return (
        arr?.delivery_states
          ?.find((e) => e.status == arr.delivery_status)
          .delivery_states_multilanguage?.find((elm) => elm?.language == 'en')
          ?.title || 'Status config'
      )
    }
  },
  watch: {
    '$store.state.language.currLanguage': function () {
      this.currLanguage = this.$store.state.language.currLanguage
    }
  },
  setup() {
    const dataTag = ref({})
    const {
      timeout,
      showTable,
      fetchOrdersList,
      tableColumns,
      perPage,
      currentPage,
      totals,
      dataMeta,
      searchQuery,
      followMode,
      sortBy,
      isSortDirDesc,
      refOrdersTable,
      refetchData,
      allOpenRows,
      ORDERS_STATUS,
      getOrderStatus,
      recordDetail,
      showDetailOrder,
      statusFilterOptions,
      statusFilter,
      fromDate,
      toDate,
      isLoading,
    } = useOrdersList();

    return {
      timeout,
      showTable,
      dataTag,
      fetchOrdersList,
      tableColumns,
      perPage,
      currentPage,
      totals,
      dataMeta,
      searchQuery,
      followMode,
      sortBy,
      isSortDirDesc,
      refOrdersTable,
      refetchData,
      allOpenRows,
      ORDERS_STATUS,
      getOrderStatus,
      recordDetail,
      showDetailOrder,
      statusFilterOptions,
      statusFilter,
      fromDate,
      toDate,
      isLoading
    };
  },
};
</script>

<style lang="scss">
.avatar {
  min-width: 40px;
  max-width: 40px;
  height: 40px;
  top: -20px;
}
.b-table-details {
  background-color: #f6f6f9;
}
.padding-sm {
  padding: 0.72rem 0.5rem !important;
}
.margin-b-4 {
  margin-bottom: 4px;
}
.fade-loading {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #2cccff;
  border-radius: 100rem;
  margin-right: -11px;
  transform: translate(-16px, -1px);
  position: relative;
}

.fade-loading:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background-color: inherit;
  animation: fade 1s forwards infinite linear;
}

@keyframes fade {
  to {
    transform: scale(2);
    opacity: 0;
  }
}
</style>
